
<template>
  <div id="user-edit-profile">
    <div class="row gx-3 gy-3 mb-4">
      <div class="col-md-6">
        <label class="form-label" for="firstName">First name</label>
        <input disabled id="firstName" type="text" class="form-control" v-model="data.first_name"
        :class="{ 'is-invalid': v$.data.first_name.$error }" placeholder="First name" name="first_name" />
        <div v-for="(item, index) in v$.data.first_name.$errors"
          :key="index" class="invalid-feedback">
          <span v-if="item.$message">{{ item.$message }}</span>
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label" for="middleName">Middle name</label>
        <input id="middleName" type="text" class="form-control" v-model="data.middle_name"
         placeholder="Middle name" name="middle_name" />
      </div>
      <div class="col-md-6">
        <label class="form-label" for="LastName">Last name</label>
        <input disabled id="LastName" type="text" class="form-control" v-model="data.last_name"
        :class="{ 'is-invalid': v$.data.last_name.$error }"  placeholder="Last Name" name="last_name" />
        <div v-for="(item, index) in v$.data.last_name.$errors"
          :key="index" class="invalid-feedback">
          <span v-if="item.$message">{{ item.$message }}</span>
        </div>
      </div>
      <div class="col-md-6">
          <label class="form-label" for="inputEmail">Email Address</label>
          <input disabled id="inputEmail" :readonly="!!data.is_verified" label="Email" v-model="data.email"
          :class="{ 'is-invalid': v$.data.email.$error }" type="email" name="email" class="form-control"/>
          <div v-for="(item, index) in v$.data.email.$errors"
            :key="index" class="invalid-feedback">
            <span v-if="item.$message">{{ item.$message }}</span>
          </div>  
      </div>
      <div class="col-md-6">
        <label class="form-label" for="inputMobile">Mobile <span class="text-muted">(change to your phone number)</span></label>
        <input id="inputMobile" autocomplete="false" type="text" class="form-control" v-model="data.mobile"
          :class="{ 'is-invalid': v$.data.mobile.$error  }" placeholder="mobile" name="mobile" />
        <div v-for="(item, index) in v$.data.mobile.$errors"
          :key="index" class="invalid-feedback">
          <span v-if="item.$message">{{ item.$message }}</span>
        </div>
      </div>
      <div class="col-md-6">
        <label for="gender" class="form-label">Gender</label>
        <select v-model="data.gender" name="gender" id="gender" class="form-select"
        :class="{ 'is-invalid': v$.data.gender.$error }" >
          <option disabled :value="null" >--select gender--</option>
          <option v-for="(gender, gdIndex) in genderOptions" :key="gdIndex" 
            :value="gender.value">{{gender.label}}</option>
        </select>
        <div v-for="(item, index) in v$.data.gender.$errors"
          :key="index" class="invalid-feedback">
          <span v-if="item.$message">{{ item.$message }}</span>
        </div> 
      </div>
      <div class="col-12">
        <label class="form-label" for="ProfileImage">Change profile photo</label>
        <div class="d-sm-flex align-items-end">
          <div class="me-sm-3 mb-3 mb-sm-0">
            <img v-if="data.image" width="100" class="" :src="absoluteUrl(data.image)" alt="profile logo" />
            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="100" height="100" viewBox="0 0 256 256" xml:space="preserve">
              <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
                  <path d="M 90 90 H 77.615 c -21.744 -5.296 -43.487 -5.296 -65.231 0 H 0 V 0 h 90 V 90 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(200,209,230); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                  <path d="M 67.319 68.576 l -4.863 -2.716 c -3.576 -1.997 -6.386 -4.994 -8.161 -8.53 c 2.468 -3.578 4.072 -8.116 4.271 -11.885 h 0.022 l 1.346 -6.015 c 0.298 -1.332 -0.306 -2.604 -1.346 -3.293 v -2.179 c 0 -6.227 -4.193 -13.335 -9.906 -15.582 l 0.009 -0.015 c -2.81 -1.268 -6.633 -1.184 -8.423 -0.718 c 1.849 0.664 2.835 2.557 0.425 3.426 l 0.022 0.001 c -5.402 1.796 -9.302 6.882 -9.302 12.887 v 2.179 c -1.041 0.689 -1.644 1.96 -1.346 3.293 l 1.346 6.015 h 0.022 c 0.199 3.769 1.802 8.307 4.271 11.885 c -1.775 3.536 -4.586 6.533 -8.161 8.53 l -4.863 2.716 c -6.357 3.55 -10.296 10.262 -10.296 17.543 V 90 h 65.231 v -3.881 C 77.615 78.838 73.676 72.126 67.319 68.576 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(247,247,247); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
              </g>
            </svg>
          </div>
          <div class="">
            <profile-image-capture :enableUpload="true" @uploadSuccess="($event) => { data.image = $event}"/>
          </div>
        </div>
        <div v-for="(item, index) in v$.data.image.$errors"
          :key="index" class="mt-2" >
          <span v-if="item.$message" class="small text-danger">{{ item.$message }}</span>
        </div>
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12">
        <div class="text-end">
          <button type="button" @click.prevent="updateUser()" class="btn btn-primary mt-2">
            Save Changes
          </button>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { required, email, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import ProfileImageCapture from '@/components/forms/ProfileImageCapture.vue';

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components:{
    ProfileImageCapture
  },
  props:{
    editItem:{
      type: Object,
      default: null
    },
  },
  watch:{
    'editItem': function(_){
      this.patchUser()
    }
  },
  data() {
    return {
      genderOptions: [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' },
        { label: 'Others', value: 'others' }
      ],
      data: {
        first_name: "",
        middle_name: "",
        last_name: "",
        email: "",
        mobile: "",
        gender: null,
        image: "",
      }
    }
  },
  validations: {
    data:{
      first_name: {
        required: helpers.withMessage("First name is required", required),
      },
      last_name: {
        required: helpers.withMessage("Last name is required", required),
      },
      email: {
        required: helpers.withMessage("Email is required", required),
        email: helpers.withMessage("Please enter valid email", email),
      },
      mobile: {
        required: helpers.withMessage("Phone number is required", required),
      },
      gender: {
        required: helpers.withMessage("Gender is required", required),
      },
      image: {
        required: helpers.withMessage("Profile photo is required", required),
      }
    }
  },
  methods: {
    updateUser() {
      this.v$.$validate().then(result =>{
        if (!result) { this.alertError(this.v$.$errors[0].$message); return;}
        const formData = new FormData()
        formData.append('data', JSON.stringify(this.data))
        this.$store.dispatch("changeLoaderValue", true)
        this.$http.post('/account/update', formData)
        .then((response) => {
            this.$store.dispatch("changeLoaderValue", false)
            if(response.data.success){
              this.$emit('updateItem', response.data.data)
              this.$emit('closeMe')
              this.$store.dispatch("fetchActiveUser");
            }
        })
      })
    },
    patchUser(){
      console.log(this.editItem)
      this.data = this.$filters.patchUpdatables(this.data, this.editItem)
    },
  },
  mounted(){
    this.patchUser()
  },
}
</script>
